export const permissionsQueryKeys = {
  boxes: {
    allUsersPermissions: ['boxes', 'usersPermissions'],
    usersPermissionsForBoxId: (boxId: number) => ['boxes', 'usersPermissions', boxId],
    isOpen: (boxId: number) => ['boxes', 'isOpen', boxId],
    permissionStatus: (boxId: number) => ['boxes', 'permissionStatus', boxId],
  },
};
